import React from 'react';
import useTranslation from 'next-translate/useTranslation';

import { TariffCard } from '@/ui/index';

import styles from './styles.module.scss';

const SearchResult = ({ data }) => {
  const { t } = useTranslation();
  const renderTariff = (tariff, index) => {
    return (
      <TariffCard
        key={`${index}_tariff`}
        item={tariff}
        itemScope
        itemType='http://schema.org/ListItem'
      />
    );
  };

  return (
    <div className={'wrapper'} itemScope itemType='http://schema.org/ItemList'>
      <div className={styles.title}>{t('common:searchResult')}</div>
      <div className={styles.content}>{data.map(renderTariff)}</div>
    </div>
  );
};

export default SearchResult;
